import { render, staticRenderFns } from "./questionPaper.vue?vue&type=template&id=6f5f741c"
import script from "./questionPaper.vue?vue&type=script&lang=js"
export * from "./questionPaper.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports